"use strict";
window.theme = window.theme || {};
/* T6.24 (10 Sep 2026) - Cart drawer upsell row ("relevant add-ons").
   Replaces the dormant metaobject/country-gated version. Keeps the same global
   (theme.CartDrawerUpsell with .load()) because component-cart-drawer.js,
   component-quick-view.js and component-product-page.js call it after every
   cart change.
   Flow: read the seed marker that the drawer form re-renders on every change
   (#form-cart-drawer .lkc-cart-upsell-seed: newest non-gift product id, item
   count, total, line keys) -> fetch /?section_id=cart-drawer-upsell (the section
   renders the whole row server-side via snippets/similar-products.liquid, the
   newest item's smallest theme collection, plus add-ons) -> swap it into
   #lkc-cart-upsell. A signature of the cart state (keys + total) stops the same
   state being fetched twice, including while a request is still in flight, since
   the theme fires several refresh signals per cart change (the trio call plus the
   form and drawer-class observers below).
   Buttons: [data-lkc-upsell-add] posts the pre-resolved variant id to
   /cart/add.js with sections=cart-drawer and swaps the drawer form the way
   CartDrawer.addfreegift() does (the count comes from the section HTML because
   /cart/add.js itself returns no item_count); [data-lkc-upsell-choose] opens the
   quick view. */
theme.CartDrawerUpsell = (function () {
    var inflight = 0;
    var lastSig = null;
    var pendingSig = null;
    var parser = new DOMParser();

    function box() { return document.getElementById('lkc-cart-upsell'); }
    function drawer() { return document.getElementById('cart-drawer'); }
    function seedEl() { return document.querySelector('#form-cart-drawer .lkc-cart-upsell-seed'); }
    function clear(el) { el.innerHTML = ''; el.hidden = true; }
    function drawerOpen() { var d = drawer(); return !!(d && d.classList.contains('active')); }

    function load(force) {
        var el = box();
        if (!el) return;
        var seed = seedEl();
        var pid = seed ? seed.dataset.productId : '';
        var count = seed ? (parseInt(seed.dataset.itemCount, 10) || 0) : 0;
        if (!pid || count === 0) {
            ++inflight; /* drop any response still on its way for the old cart */
            clear(el); lastSig = null; pendingSig = null;
            return;
        }
        var sig = (seed.dataset.keys || '') + '|' + (seed.dataset.total || '');
        if (!force && (sig === lastSig || sig === pendingSig)) return;
        pendingSig = sig;
        var url = el.dataset.url;
        var id = ++inflight;
        fetch(url, { headers: { 'Accept': 'text/html' } })
            .then(function (r) { if (!r.ok) { throw r; } return r.text(); })
            .then(function (html) {
                if (id !== inflight) return;
                pendingSig = null;
                var doc = parser.parseFromString(html, 'text/html');
                var inner = doc.querySelector('.lkc-cart-upsell__inner');
                if (!inner || !inner.querySelector('.lkc-cart-upsell__tile')) { clear(el); lastSig = sig; return; }
                el.innerHTML = inner.outerHTML;
                el.hidden = false;
                lastSig = sig;
            })
            .catch(function () {
                /* network error or non-OK: keep whatever is showing, allow a retry */
                if (id === inflight) pendingSig = null;
            });
    }

    function swapDrawer(data) {
        /* mirrors component-cart-drawer.js addfreegift(): the count is read from
           the re-rendered section, not from the add.js payload (which has none) */
        var doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
        var form = doc.getElementById('form-cart-drawer');
        var newCount = doc.querySelector('#cart-drawer-item-count .count-label');
        var live = document.getElementById('form-cart-drawer');
        var count = document.querySelector('#cart-drawer-item-count .count-label');
        var bubble = document.getElementById('cart-count-bubble');
        if (newCount) {
            var n = newCount.textContent.trim();
            if (count) count.textContent = n;
            if (bubble) bubble.textContent = n;
        }
        if (form && live) live.innerHTML = form.innerHTML;
    }

    async function add(btn) {
        const vid = parseInt(btn.dataset.variantId, 10);
        if (!vid || btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading');
        try {
            const answer = await theme.CartTransactions.add({ id: vid, quantity: 1 });
            const refreshed = await theme.CartTransactions.render(answer);
            if (refreshed && ['success', 'recovered', 'partial'].includes(answer.status)) {
                btn.disabled = true;
                btn.textContent = 'Added';
                load(false);
            }
        } finally {
            btn.classList.remove('is-loading');
        }
    }

    function choose(url) {
        if (!url) return;
        if (theme.QuickView && typeof theme.QuickView.rendercontent === 'function') {
            if (theme.QuickView.state) theme.QuickView.state.editMode = false;
            theme.QuickView.rendercontent(url);
        } else {
            window.location.href = url;
        }
    }

    function onClick(e) {
        var addBtn = e.target.closest('[data-lkc-upsell-add]');
        if (addBtn) { e.preventDefault(); add(addBtn); return; }
        var chooseBtn = e.target.closest('[data-lkc-upsell-choose]');
        if (chooseBtn) { e.preventDefault(); choose(chooseBtn.dataset.productUrl); }
    }

    function refresh() { if (drawerOpen()) load(false); }

    function init() {
        var d = drawer();
        if (!d || !box()) return;
        d.addEventListener('click', onClick);
        new MutationObserver(refresh).observe(d, { attributes: true, attributeFilter: ['class'] });
        var form = document.getElementById('form-cart-drawer');
        if (form) new MutationObserver(refresh).observe(form, { childList: true });
        refresh();
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

    return {
        load: refresh,
        reload: function () { if (drawerOpen()) load(true); },
        add: add,
        choose: choose
    };
})();
